import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { HttpService } from '../../http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-instant-notification',
  templateUrl: './instant-notification.component.html',
  styleUrls: ['./instant-notification.component.scss']
})
export class InstantNotificationComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;
  public loading: boolean = false;
  public pairingCode: string = "";

  constructor(private http: HttpService) {
    this.company_uuid = this.http.getStaticSelectedCompany();
  }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/setting/instant-notificatoin/get', data: {page_nat: false}},
        disabled_pagenat: false,
        fields: [{label: 'No', type: 'index'}, 
        {label: 'Title', type: 'string', key: 'title'}, 
        {label: 'Code', type: 'string', key: 'code'}, 
        {label: 'Code Expiry', type: 'timestamp', key: 'code_expiry'}, 
        {label: 'Status', type: 'notificationstatus', key: 'status'}, 
        {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/setting-notification/form', hide: true},
        {label: 'Delete', type: 'delete', key: 'uuid', table: 'notification_device', title: 'title', hide: true},
      ]}
    this.tb.init(setting);
  }

  async generatePairingCode() {
    this.loading = true;
    const res: any = await this.http.post("/admin/setting/generate-pairing-code");
    if (res.status) {
      this.pairingCode = res.code;
    }
    this.loading = false;
  }

}
